import { getDateDiffFormatted } from "@/common/utils/date";
import { bankingDepositStatus } from "@/features/privateCompanies/constants/bankingDeposits/bankingDepositStatus.constant";
import { BankingDepositsData } from "@/features/privateCompanies/types/bankingDeposits/bankingDeposits.type";
import { isAfter } from "date-fns";
import { CalendarXIcon, TimerIcon } from "lucide-react";

interface StatusTableCellProps {
  bankingDeposit: BankingDepositsData;
}

const StatusTableCell = ({ bankingDeposit }: StatusTableCellProps) => {
  const isExpiredDateBeforeNow = bankingDeposit?.payment?.source?.expires_at &&
    isAfter(new Date(bankingDeposit.payment.source.expires_at), new Date());

  if (!bankingDeposit.status) {
    return null;
  }

  return (
    <div className="space-y-0.5">
      <p>
        {bankingDepositStatus[bankingDeposit.status as keyof typeof bankingDepositStatus]}
      </p>

      {bankingDeposit.status === "pending" && bankingDeposit.payment?.source?.expires_at && (
        <>
          {isExpiredDateBeforeNow ? (
            <div className="flex items-center gap-1">
              <TimerIcon className="text-yellow-400" size={18} strokeWidth={1.5} />

              <p className="italic text-sm font-light">
                {getDateDiffFormatted(new Date(bankingDeposit?.payment?.source?.expires_at), new Date())}
              </p>
            </div>
          ) : (
            <div className="flex items-center gap-1">
              <CalendarXIcon className="text-danger-soft" size={18} strokeWidth={1.5} />

              <p className="italic text-sm font-light">
                Vencido
              </p>
            </div>
          )}
        </>
      )}

    </div>
  );
}

export default StatusTableCell;
